module.exports = __webpack_public_path__ + "img/typeall.28610250.png";